/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EnterpriseInputs */

const en_enterprise = /** @type {(inputs: EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const es_enterprise = /** @type {(inputs: EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresarial`)
};

const fr_enterprise = /** @type {(inputs: EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const de_enterprise = /** @type {(inputs: EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const id_enterprise = /** @type {(inputs: EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perusahaan`)
};

/** @type {(inputs: EnterpriseInputs) => LocalizedString} */
const ja_enterprise = en_enterprise;

/** @type {(inputs: EnterpriseInputs) => LocalizedString} */
const zh_enterprise = en_enterprise;

/** @type {(inputs: EnterpriseInputs) => LocalizedString} */
const ar_enterprise = en_enterprise;

/** @type {(inputs: EnterpriseInputs) => LocalizedString} */
const it_enterprise = en_enterprise;

/** @type {(inputs: EnterpriseInputs) => LocalizedString} */
const ru_enterprise = en_enterprise;

/** @type {(inputs: EnterpriseInputs) => LocalizedString} */
const pt_enterprise = en_enterprise;

/** @type {(inputs: EnterpriseInputs) => LocalizedString} */
const ko_enterprise = en_enterprise;

/**
* | output |
* | --- |
* | "Enterprise" |
*
* @param {EnterpriseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enterprise = /** @type {((inputs?: EnterpriseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EnterpriseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enterprise(inputs)
	if (locale === "es") return es_enterprise(inputs)
	if (locale === "fr") return fr_enterprise(inputs)
	if (locale === "de") return de_enterprise(inputs)
	if (locale === "ja") return ja_enterprise(inputs)
	if (locale === "zh") return zh_enterprise(inputs)
	if (locale === "ar") return ar_enterprise(inputs)
	if (locale === "id") return id_enterprise(inputs)
	if (locale === "it") return it_enterprise(inputs)
	if (locale === "ru") return ru_enterprise(inputs)
	if (locale === "pt") return pt_enterprise(inputs)
	return ko_enterprise(inputs)
});